import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import LOCALES_QUERY from '../queries/LOCALES_QUERY';
 
const useLocales = () => {
    const [ locales, setLocales ] = useState( [] );
    const { data, loading, error } = useQuery( LOCALES_QUERY );
 
    useEffect( () => {
        if ( loading || error || !data || !data.locales?.edges ) { return; }
        
        try {
            const result = data.locales.edges.map( i => { 
                return {
                    key: i.node?.code || '',
                    code: i.node?.code || '',
                    label: i.node?.labelEnUs || '',
                    labelOrignal: i.node?.label || ''
                }; 
            } );

            setLocales( result );
        } catch ( error ) {
            console.error( 'Error parsing locales', error ); 
            setLocales( [] );
        }
    }, [ loading, error ] );
    
    const getLocale = ( code ) => locales.find( i => i.code === code );
    const getLocaleLabel = ( code ) => getLocale( code )?.label || code;

    return useMemo( () => {
        return {
            locales,
            localesError: error,
            localesLoading: loading,
            getLocale,
            getLocaleLabel
        };
    }, [ locales, error, loading ] );
};

export default useLocales;
